<template>
<svg :width="size" :height="size" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#F4F7FB" />
    <path d="M20.667 13.334H16.0003C15.6467 13.334 15.3076 13.4745 15.0575 13.7245C14.8075 13.9746 14.667 14.3137 14.667 14.6673V25.334C14.667 25.6876 14.8075 26.0267 15.0575 26.2768C15.3076 26.5268 15.6467 26.6673 16.0003 26.6673H24.0003C24.3539 26.6673 24.6931 26.5268 24.9431 26.2768C25.1932 26.0267 25.3337 25.6876 25.3337 25.334V18.0007L20.667 13.334Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M20.667 13.334V18.0007H25.3337" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: '40'
        },
        color: {
            default: '#727D94'
        }
    }
}
</script>